import { Livewire } from '../../vendor/livewire/livewire/dist/livewire.esm'
import * as Sentry from "@sentry/browser";
import '@github/relative-time-element';

import.meta.glob([
  '../images/**',
]);

Sentry.init({
    dsn: window.sentry_dsn,
    release: window.sentry_release,
    environment: window.sentry_environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: window.sentry_traces_sample_rate,
});

Livewire.start();
